/**
 * Google Maps 관련 유틸리티 함수
 */

/**
 * Google Maps Location 객체를 { lat, lng } 형태로 변환
 * @param {google.maps.LatLng|google.maps.LatLngLiteral} location
 * @returns {{ lat: number, lng: number }}
 */
export const extractLatLng = (location) => {
  if (!location) return null;
  
  const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
  const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
  
  return { lat, lng };
};

/**
 * 기본 지도 중심 좌표
 */
export const DEFAULT_CENTER = {
  lat: -3.745,
  lng: -38.523,
};

/**
 * 기본 줌 레벨
 */
export const DEFAULT_ZOOM = 13;

